module.exports = __webpack_public_path__ + "static/img/egg_g_14.2d0a2e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_14.png
// module id = L9Ft
// module chunks = 1